import type { MenuItem, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'menu/items';

export function getMenuItems(query: MenuItem.SearchQuery) {
    return api.get<Pagination<MenuItem>>(rootPath, query);
}

export function getMenuItem(id: number) {
    return api.get<MenuItem.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postMenuItem(data: MenuItem.CreateRequest) {
    return api.post<MenuItem>(rootPath, data);
}

export function putMenuItem(id: number, data: MenuItem.UpdateRequest) {
    return api.put<MenuItem>(`${rootPath}/${id}`, data);
}

export function deleteMenuItem({ id }: MenuItem.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
